import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.comms.docked_left = !next.selected.comms.docked_left
    })
  }
}
